export const DASHBOARD_PAGE = "dashboard-qokri";
export const GUIDELINES_PAGE = "guidelines-84jd3";
export const REVIEW_PAGE = "review-fb54d";
export const SIGN_IN_PAGE = "sign-in-fb54d";
export const WELCOME_PAGE = "welcome-853f8";
